import {
    AltPaths,
    Facet,
    GridCategory,
    GridCategoryMetas,
} from "../../model/grid.model";

export const getCanonicalUrlForCategory = (
    frontendUrl: string,
    params: {
        categoryMetas: GridCategoryMetas;
        combinedFacetActivated: boolean;
        facet: Facet;
        seoPageParam: number;
    },
): string => {
    const categoryCanonicalUrl = `${frontendUrl}${params.categoryMetas.path}`;

    if (params.facet?.enabled) {
        return `${frontendUrl}${params.facet.path}`;
    }
    if (params.seoPageParam > 1) {
        return `${categoryCanonicalUrl}?page=${params.seoPageParam}`;
    }
    return categoryCanonicalUrl;
};

export const getDescriptionForCategory = (params: {
    category: GridCategory;
    categoryMetas: GridCategoryMetas;
    combinedFacetActivated: boolean;
    facet?: Facet;
}): string => {
    const { masterCategoryName: masterCategory, name: category } =
        params.category;
    return params.facet?.enabled
        ? $localize`:@@hermes-global-translations.meta.description.filtered.product.grid:${params.facet.facetDisplayName}:INTERPOLATION: • Discover our collection : ${params.facet.facetDisplayName}:INTERPOLATION_1: - ${masterCategory}:INTERPOLATION_2: - ${category}:INTERPOLATION_3: on the official Hermès online store !`
        : params.categoryMetas.description;
};

export const getAlternatePathsForCategory = (params: {
    categoryMetas: GridCategoryMetas;
    combinedFacetActivated: boolean;
    facet: Facet;
}): AltPaths =>
    params.facet?.enabled &&
    params.facet.altPaths !== undefined &&
    Object.keys(params.facet?.altPaths).length > 0
        ? params.facet.altPaths
        : params.categoryMetas.altPaths;
